import { Action } from 'redux'
import { IEvent } from '../../models/Event'
import { ITemplate } from '../../models/Templates'
import { TemplateSend } from '../../reducers/templates/actionNames'

const toggleTemplateSendModal = (
  toggle: boolean,
  email?: string,
  event?: IEvent,
): IToggleTemplateSendModal => ({
  email,
  event,
  toggle,
  type: TemplateSend.ToggleTemplateSendModal,
})

const toggleTemplateSendModalLoading = (
  loading = false,
): IToggleTemplateSendModalLoading => ({
  loading,
  type: TemplateSend.ToggleTemplateSendModalLoading,
})

const openTemplateSendModal = (): Action => ({
  type: TemplateSend.OpenTemplateSendModal,
})

const sendTemplate = (template: ITemplate): ISendTemplate => ({
  template: template,
  type: TemplateSend.SendTemplate,
})

export {
  toggleTemplateSendModal,
  toggleTemplateSendModalLoading,
  openTemplateSendModal,
  sendTemplate,
}

export interface IToggleTemplateSendModal extends Action {
  email?: string
  event?: IEvent
  toggle: boolean
}

export interface IToggleTemplateSendModalLoading extends Action {
  loading?: boolean
}

export interface ISendTemplate extends Action {
  template: ITemplate
}
